export const operators = [
    { value: 'equal', label: 'Equals' },
    { value: 'notEqual', label: 'Does not equal' },
    { value: 'lessThan', label: 'Less than' },
    { value: 'lessThanInclusive', label: 'Less than or equal' },
    { value: 'greaterThan', label: 'Greater than' },
    { value: 'greaterThanInclusive', label: 'Greater than or equal' },
    { value: 'hasValue', label: 'Has a value' },
    { value: 'matches', label: 'Matches' },
    { value: 'doesNotMatch', label: 'Does not match' },
    { value: 'in', label: 'In' },
    { value: 'notIn', label: 'Not in' },
];

export const operatorsForBoolean = [
    { value: 'equal', label: 'Equals' },
    { value: 'notEqual', label: 'Does not equal' },
    { value: 'hasValue', label: 'Has a value' },
];
